export default __webpack_public_path__ + "static/media/Foot_left.2039c4c7.svg";